import { render, staticRenderFns } from "./geneTableList.vue?vue&type=template&id=2dab0ec2&scoped=true"
import script from "./geneTableList.vue?vue&type=script&lang=js"
export * from "./geneTableList.vue?vue&type=script&lang=js"
import style0 from "./geneTableList.vue?vue&type=style&index=0&id=2dab0ec2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dab0ec2",
  null
  
)

export default component.exports